export default __webpack_public_path__ + "static/media/IntellectualPoint-JobBoard.455a78cc.png";